import { render, staticRenderFns } from "./FletrixTextField.vue?vue&type=template&id=5b637912&scoped=true&"
import script from "./FletrixTextField.vue?vue&type=script&lang=js&"
export * from "./FletrixTextField.vue?vue&type=script&lang=js&"
import style0 from "./FletrixTextField.vue?vue&type=style&index=0&id=5b637912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b637912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
